import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Textarea } from '@/components/ui/textarea'

export const CompanyContextField = () => {
  const { control } = useFormContext()
  const { t } = useTranslation()

  return (
    <FormField
      control={control}
      name="description"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {t('dashboard.runReport.companyInfoFields.description')}
          </FormLabel>
          <FormDescription>
            {t('dashboard.runReport.companyInfoFields.descriptionHint')}
          </FormDescription>
          <FormControl>
            <Textarea
              {...field}
              value={field.value ?? ''}
              maxLength={2000}
              placeholder={t(
                'dashboard.runReport.companyInfoFields.descriptionPlaceholder',
              )}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}
